import robotActuatorJoint1 from '../../images/projects/robot-actuator-joint/robot-actuator-joint-1.png';
import robotActuatorJoint2 from '../../images/projects/robot-actuator-joint/robot-actuator-joint-2.jpeg';
import robotActuatorJoint3 from '../../images/projects/robot-actuator-joint/robot-actuator-joint-3.png';
import robotActuatorJoint4 from '../../images/projects/robot-actuator-joint/robot-actuator-joint-4.jpeg';
import robotActuatorJoint5 from '../../images/projects/robot-actuator-joint/robot-actuator-joint-5.jpeg';

import ros_3dVisionInspectionSystem1 from '../../images/projects/ros-3d-vision-inspection-system/ros-3d-vision-inspection-system-1.jpg';
import ros_3dVisionInspectionSystem2 from '../../images/projects/ros-3d-vision-inspection-system/ros-3d-vision-inspection-system-2.jpg';
import ros_3dVisionInspectionSystem3 from '../../images/projects/ros-3d-vision-inspection-system/ros-3d-vision-inspection-system-3.jpg';

import humanoidRobot1 from '../../images/projects/humanoid-robot/humanoid-robot-1.jpeg';
import humanoidRobot2 from '../../images/projects/humanoid-robot/humanoid-robot-2.jpeg';
import humanoidRobot3 from '../../images/projects/humanoid-robot/humanoid-robot-3.jpeg';
import humanoidRobot4 from '../../images/projects/humanoid-robot/humanoid-robot-4.jpeg';
import humanoidRobot5 from '../../images/projects/humanoid-robot/humanoid-robot-5.jpeg';
import humanoidRobot6 from '../../images/projects/humanoid-robot/humanoid-robot-6.jpeg';
import humanoidRobot7 from '../../images/projects/humanoid-robot/humanoid-robot-7.jpeg';
import humanoidRobot8 from '../../images/projects/humanoid-robot/humanoid-robot-8.jpeg';
import humanoidRobot9 from '../../images/projects/humanoid-robot/humanoid-robot-9.jpeg';
import humanoidRobot10 from '../../images/projects/humanoid-robot/humanoid-robot-10.jpeg';
import humanoidRobot11 from '../../images/projects/humanoid-robot/humanoid-robot-11.jpeg';
import humanoidRobot12 from '../../images/projects/humanoid-robot/humanoid-robot-12.jpeg';

import swerveDrive1 from '../../images/projects/swerve-drive/swerve-drive-1.jpg';
import swerveDrive2 from '../../images/projects/swerve-drive/swerve-drive-2.jpg';
import swerveDrive3 from '../../images/projects/swerve-drive/swerve-drive-3.jpg';
import swerveDrive4 from '../../images/projects/swerve-drive/swerve-drive-4.jpg';
import swerveDrive5 from '../../images/projects/swerve-drive/swerve-drive-5.jpg';

import shipTankCleaningRobot1 from '../../images/projects/ship-tank-cleaning-robot/ship-tank-cleaning-robot-1.jpg';
import shipTankCleaningRobot2 from '../../images/projects/ship-tank-cleaning-robot/ship-tank-cleaning-robot-2.jpg';
import shipTankCleaningRobot3 from '../../images/projects/ship-tank-cleaning-robot/ship-tank-cleaning-robot-3.jpg';
import shipTankCleaningRobot4 from '../../images/projects/ship-tank-cleaning-robot/ship-tank-cleaning-robot-4.jpg';
import shipTankCleaningRobot5 from '../../images/projects/ship-tank-cleaning-robot/ship-tank-cleaning-robot-5.jpg';

import cycloidalGearDrive1 from '../../images/projects/cycloidal-gear-drive/cycloidal-gear-drive-1.jpg';
import cycloidalGearDrive2 from '../../images/projects/cycloidal-gear-drive/cycloidal-gear-drive-2.jpg';
import cycloidalGearDrive3 from '../../images/projects/cycloidal-gear-drive/cycloidal-gear-drive-3.jpg';
import cycloidalGearDrive4 from '../../images/projects/cycloidal-gear-drive/cycloidal-gear-drive-4.jpg';
import cycloidalGearDrive5 from '../../images/projects/cycloidal-gear-drive/cycloidal-gear-drive-5.jpg';

import quadrupedRobot1 from '../../images/projects/quadruped-robot/quadruped-robot-1.jpg';
import quadrupedRobot2 from '../../images/projects/quadruped-robot/quadruped-robot-2.jpg';
import quadrupedRobot3 from '../../images/projects/quadruped-robot/quadruped-robot-3.jpg';
import quadrupedRobot4 from '../../images/projects/quadruped-robot/quadruped-robot-4.jpg';
import quadrupedRobot5 from '../../images/projects/quadruped-robot/quadruped-robot-5.jpg';

import bionicArm1 from '../../images/projects/bionic-arm/bionic-arm-1.jpg';
import bionicArm2 from '../../images/projects/bionic-arm/bionic-arm-2.jpg';
import bionicArm3 from '../../images/projects/bionic-arm/bionic-arm-3.jpg';
import bionicArm4 from '../../images/projects/bionic-arm/bionic-arm-4.jpg';

import snapFitCase1 from '../../images/projects/snap-fit-case/snap-fit-case-1.jpg';
import snapFitCase2 from '../../images/projects/snap-fit-case/snap-fit-case-2.jpg';
import snapFitCase3 from '../../images/projects/snap-fit-case/snap-fit-case-3.jpg';
import snapFitCase4 from '../../images/projects/snap-fit-case/snap-fit-case-4.jpg';
import snapFitCase5 from '../../images/projects/snap-fit-case/snap-fit-case-5.jpg';
import snapFitCase6 from '../../images/projects/snap-fit-case/snap-fit-case-6.jpg';
import snapFitCase7 from '../../images/projects/snap-fit-case/snap-fit-case-7.jpg';

import dualExtruder3dPrinter1 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-1.jpg';
import dualExtruder3dPrinter2 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-2.jpg';
import dualExtruder3dPrinter3 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-3.jpg';
import dualExtruder3dPrinter4 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-4.jpg';
import dualExtruder3dPrinter5 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-5.jpg';
import dualExtruder3dPrinter6 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-6.jpg';
import dualExtruder3dPrinter7 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-7.jpg';
import dualExtruder3dPrinter8 from '../../images/projects/dual-extruder-3d-printer/dual-extruder-3d-printer-8.jpg';

import fourWheelMecanumDrive1 from '../../images/projects/four-wheel-mecanum-drive/four-wheel-mecanum-drive-1.jpg';
import fourWheelMecanumDrive2 from '../../images/projects/four-wheel-mecanum-drive/four-wheel-mecanum-drive-2.jpg';
import fourWheelMecanumDrive3 from '../../images/projects/four-wheel-mecanum-drive/four-wheel-mecanum-drive-3.jpg';
import fourWheelMecanumDrive4 from '../../images/projects/four-wheel-mecanum-drive/four-wheel-mecanum-drive-4.jpg';

export const PROJECTS = [
  {
    displayTitle: 'ROS-based Automated 3D Vision Inspection System',
    subTitle: '',
    tags: ['ROS'],
    description: (
      <>
        <ul>
          <li>
            Innovated a system dedicated to scanning 3D objects within a
            workspace, utilizing a robotic arm equipped with a 2D LiDAR mounted
            on the end effector.
          </li>
          This technology enables automatic vision inspection,
          <li>
            particularly beneficial for intricate objects like a crankshaft,
            thereby eliminating the necessity for manual assembly line
            inspections.
          </li>
          <li>
            The project represents a significant leap towards streamlined and
            automated quality control processes, enhancing efficiency and
            precision in manufacturing and inspection workflows
          </li>
        </ul>
      </>
    ),
    images: [
      ros_3dVisionInspectionSystem1,
      ros_3dVisionInspectionSystem2,
      ros_3dVisionInspectionSystem3,
    ],
  },
  {
    displayTitle: 'Custom Compact Robot Actuator for Heavy Load Applications',
    subTitle: 'August 2022',
    tags: [
      'Mechanical Design',
      'CAD',
      'Manufacturing',
      'Gear Design',
      'Torque Calculations',
      'Material and Motor Selection',
    ],
    description: (
      <>
        <ul>
          <li>
            This project involves the design and manufacturing of a specialized
            robot actuator tailored for heavy-load applications.
          </li>
          <li>
            Engineered to function as an elbow joint in a robotic arm, the
            custom actuator incorporates a gear reduction of 10:1, utilizing a
            NEMA-17 Stepper Motor to generate an impressive 42 Kg-cm of torque.
          </li>
          <li>
            The result is a compact and powerful solution, ideal for demanding
            tasks requiring precise and robust robotic arm movements
          </li>
        </ul>
      </>
    ),
    images: [
      robotActuatorJoint1,
      robotActuatorJoint2,
      robotActuatorJoint3,
      robotActuatorJoint4,
      robotActuatorJoint5,
    ],
  },
  {
    displayTitle: 'Humanoid Robot',
    subTitle: 'April 2021',
    tags: [
      'Mechanical Design',
      'Robotics',
      'SolidWorks',
      'ANSYS',
      'Mechanical Design',
      'Stress Analysis',
      'Machining',
      'Additive Manufacturing',
    ],
    description: (
      <>
        <ul>
          <li>
            Led the design and development of parallel manipulators dedicated to
            achieving precise neck movements in a humanoid robot.
          </li>
          <li>
            Engineered custom linear actuators to enhance shoulder joint
            functionality, with meticulous gear design calculations ensuring
            optimal performance.
          </li>
          <li>
            Created detailed mechanical drafts for machining operations and
            laser cutting, incorporating accurate geometric dimensions and
            tolerances.
          </li>
          <li>
            This project aims to advance the capabilities of humanoid robots by
            focusing on intricate manipulator design for precise and efficient
            upper body movements.
          </li>
        </ul>
      </>
    ),
    images: [
      humanoidRobot1,
      humanoidRobot2,
      humanoidRobot3,
      humanoidRobot4,
      humanoidRobot5,
      humanoidRobot6,
      humanoidRobot7,
      humanoidRobot8,
      humanoidRobot9,
      humanoidRobot10,
      humanoidRobot11,
      humanoidRobot12,
    ],
  },
  {
    displayTitle: 'Dual Extruder 3D Printer',
    subTitle: '',
    tags: ['3D Printing', 'SolidWorks', 'CAD', '3D Modeling'],
    description: (
      <>
        <ul>
          <li>
            Design and develop a compact and efficient 3D printer featuring dual
            extruders for simultaneous multi-material or multi-color printing.
          </li>
          <li>
            With a spacious 250x250mm bed, this printer aims to provide high
            precision, user-friendly controls, and seamless compatibility with
            various 3D printing materials.
          </li>
          <li>
            Perfect for prototyping and intricate designs, this project focuses
            on delivering a versatile and reliable 3D printing solution.
          </li>
        </ul>
      </>
    ),
    images: [
      dualExtruder3dPrinter1,
      dualExtruder3dPrinter2,
      dualExtruder3dPrinter3,
      dualExtruder3dPrinter4,
      dualExtruder3dPrinter5,
      dualExtruder3dPrinter6,
      dualExtruder3dPrinter7,
      dualExtruder3dPrinter8,
    ],
  },
  {
    displayTitle: 'AI-Enhanced Legged Walking Robot for Elderly Care',
    subTitle: '',
    tags: [
      'Robotics',
      '3D Printing',
      'CAD',
      'Computer Vision',
      'Edge Computing',
    ],
    description: (
      <>
        <ul>
          <li>
            Developed using Fusion 360, this project introduces a quadruped
            walking robot designed to serve as a caregiver for elderly
            individuals living alone.
          </li>
          <li>
            The robot's four-leg design ensures stability and maneuverability,
            while embedded AI features, powered by a Raspberry Pi, provide
            assistance and support.
          </li>
          <li>
            The integration of AI enhances the robot's ability to aid and
            monitor elderly persons, contributing to their safety and well-being
            within a home environment.
          </li>
        </ul>
      </>
    ),
    images: [
      quadrupedRobot1,
      quadrupedRobot2,
      quadrupedRobot3,
      quadrupedRobot4,
      quadrupedRobot5,
    ],
  },
  {
    displayTitle: 'Cycloidal Drive Design',
    subTitle: '',
    tags: [
      'Mechanical Engineering',
      'Mechanical Design',
      'Machine Design',
      '3D Modeling',
      'Design for Manufacturing',
      'CAD',
      'SolidWorks',
    ],
    description: (
      <>
        <ul>
          <li>
            This project centers around the meticulous design of a compact
            cycloidal drive, boasting a 100mm outer diameter and 45mm width.
          </li>
          <li>
            The drive is engineered to feature a 21:1 gear ratio, enhancing its
            efficiency in mechanical power transmission.
          </li>
          <li>
            The optimized design not only prioritizes space efficiency but also
            ensures precision and reliability.
          </li>
          <li>
            This compact cycloidal drive is well-suited for diverse
            applications, offering a powerful solution for industries that
            demand precise motion control and compact mechanical systems.
          </li>
        </ul>
      </>
    ),
    images: [
      cycloidalGearDrive1,
      cycloidalGearDrive2,
      cycloidalGearDrive3,
      cycloidalGearDrive4,
      cycloidalGearDrive5,
    ],
  },
  {
    displayTitle: 'Autonomous Mobile Robot (Mecanum Drive)',
    subTitle: '',
    tags: [
      'CAD',
      'Autonomous Vehicles',
      'Sensor Fusion',
      'Raspberry Pi',
      'Robotics',
      'Python',
    ],
    description: (
      <>
        <ul>
          <li>
            Pioneered the design of a robust mecanum drive robot tailored for
            high-load capacity in autonomous warehouse management operations.
          </li>
          <li>
            With a remarkable 100kg payload capability, the robot integrates
            Simultaneous Localization and Mapping (SLAM), 2D lidar technology,
            and ROS (Robot Operating System).
          </li>
          <li>
            This project addresses the growing demand for efficient and
            autonomous warehouse logistics by combining advanced mobility with
            cutting-edge perception and mapping technologies.
          </li>
          <li>
            The result is a versatile solution poised to revolutionize warehouse
            operations through seamless autonomy and payload handling
            capabilities.
          </li>
        </ul>
      </>
    ),
    images: [
      fourWheelMecanumDrive1,
      fourWheelMecanumDrive2,
      fourWheelMecanumDrive3,
      fourWheelMecanumDrive4,
    ],
  },
  {
    displayTitle: '3D Printed Snap Fit Case Designs',
    subTitle: '',
    tags: ['3D Printing'],
    description: (
      <>3D printed snap fit cover casing design for electronic components.</>
    ),
    images: [
      snapFitCase1,
      snapFitCase2,
      snapFitCase3,
      snapFitCase4,
      snapFitCase5,
      snapFitCase6,
      snapFitCase7,
    ],
  },
  {
    displayTitle: 'Bionic Arm Design',
    subTitle: '',
    tags: ['3D Printing', 'SolidWorks'],
    description: (
      <>Design of a 3D printed prosthetic arm for handicap person.</>
    ),
    images: [bionicArm1, bionicArm2, bionicArm3, bionicArm4],
  },
  {
    displayTitle: 'Ship Tank Cleaning Robot',
    subTitle: '',
    tags: ['CAD', 'SolidWorks'],
    description: (
      <>
        Design of a robot to clean oil tanks and do inspection autonomously
        along with suction and water spray functionalities.
      </>
    ),
    images: [
      shipTankCleaningRobot1,
      shipTankCleaningRobot2,
      shipTankCleaningRobot3,
      shipTankCleaningRobot4,
      shipTankCleaningRobot5,
    ],
  },
  {
    displayTitle: 'Design of Swerve Drive',
    subTitle: '',
    tags: ['CAD', 'SolidWorks'],
    description: (
      <>
        Design of a Swerve Drive with multiple gear transmission components in
        SolidWorks
      </>
    ),
    images: [
      swerveDrive1,
      swerveDrive2,
      swerveDrive3,
      swerveDrive4,
      swerveDrive5,
    ],
  },
  // {
  //   displayTitle: '3D Scan Robotic Arm | ROS | LiDAR',
  //   subTitle: '',
  //   tags: ['Robotics'],
  //   description: (
  //     <>
  //       Scanning of an 3D object in space using a robotic arm with 2D LiDAR
  //       mounted on the end effector
  //     </>
  //   ),
  //   images: [humanoidRobot1],
  // },
];

export const YOUTUBE_VIDEOS = [
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/tB9Km45fNQY',
    title: 'Humanoid Robot',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/1M_JB6N2U-E',
    title: 'LiDAR 3D Scanning Robotic Arm',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/ZtZaZfPROLs',
    title: 'Robocon 2022 || Lagori Piling || VIT Pune',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/wb66ayasfjU',
    title:
      'Robocon 2022 || Hitting Mechanism To Break Ball On Head || VIT Pune',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/gsHRoDTlpF0',
    title: 'eYRC 2023-24: Cosmo Logistic (CL) Theme Film',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/kZDejGfyAFk',
    title: 'Quadruped Robot',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/9c9WjW20Lk4',
    title: 'ROS based Autonomous Mobile Robot',
  },
  {
    videoEmbedUrl: 'https://www.youtube.com/embed/0cQYwDZK41I',
    title: 'Custom Compact Robot Actuator for Heavy Load Applications',
  },
];
